module.exports = __webpack_public_path__ + "img/safari_tips_tw.fcf1a4d0.png";